
import objectPath from 'object-path'

const getters = {
  getField: state => target => objectPath.get(state, target),
  billingData: state => state.billingData,
  methodSelectForm: state => state.methodSelectForm,
  invoiceForm: state => state.invoiceForm,
  billingForm: state => state.billingForm,
  isPaymentAvailible: (state) => {
    const {
      isLoading,
      tourists,
      bookings
    } = state.billingData

    return isLoading || (tourists.length && bookings.length)
  }
}

export default getters